import React from "react";
import _ from "lodash";
import styled from "styled-components";
import StandingsHelper from "../../classes/standingsHelper";
import useStandings from "../../hooks/queryResults/useStandings";
import useHelper from "../../hooks/useHelper";
import useWeek from "../../hooks/queryResults/useWeek";

const StyledDivTeamRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.winner {
    background-color: #ccdfff;
    font-weight: bold;
  }

  &.winning {
    background-color: #e6eeff;
  }
`;

const StyledDivTeamName = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: space-between;
  flex-grow: 5;
`;

const StyledDivTeamScore = styled.div`
  padding: 0 0.25rem;
`;

export default function GameSummaryTeam({ game, gameTeam, size, isHome }) {
  const helper = useHelper();
  const { selectedWeek } = useWeek();
  const { standingsData } = useStandings(selectedWeek);

  const loaded = !!helper && selectedWeek && standingsData;
  if (!loaded) return null;

  const standingsHelper = new StandingsHelper(standingsData);

  const { team } = gameTeam;
  const teamLogo = helper.getTeamLogoImg(team, selectedWeek, "sm");

  let teamName = team.fullName;
  let teamScore = gameTeam.getScore(isHome);

  if (size === "sm") {
    teamName = team.getAbbrSpan();
    if (teamScore > 100) {
      let adjScore = _.round(parseFloat(teamScore), 1).toFixed(1);
      teamScore = <span title={teamScore}>{adjScore}</span>;
    }
  }
  if (!teamScore) {
    // todo: later implement showing the predicted score
    // get avg
    const st = standingsHelper.getStandingsForTeam(team.obj.id);
    if (st)
      teamScore = (
        <span style={{ opacity: 0.5 }} title={"Average Points Per Game"}>
          {st.recordTotal.pointsForAvg.toFixed(2)}
        </span>
      );
  }

  const standingsStr = standingsHelper.getRecordForTeamAsStr(team.obj.id);

  const teamWon = game.obj.hasEnded && gameTeam.obj.result === "W";
  let resultClass = teamWon ? "winner" : null;

  if (!teamWon && !game.obj.hasEnded && game.obj.hasStarted) {
    if (game.isWinning(team.obj.id)) resultClass = "winning";
  }

  return (
    <StyledDivTeamRow className={resultClass}>
      <div>{teamLogo}</div>
      <StyledDivTeamName>
        {teamName}
        <span style={{ fontSize: "0.65rem", opacity: 0.65 }}>
          {standingsStr}
        </span>
      </StyledDivTeamName>
      <StyledDivTeamScore>{teamScore}</StyledDivTeamScore>
    </StyledDivTeamRow>
  );
}
